import React from "react";
import cn from "classnames";
import PropTypes from "prop-types";
import {createUseStyles} from "react-jss";
import {boldFontWeight, brandColor, darken, defaultFontSize, greenColor, lighten} from "~/theme";

const UIButton = React.forwardRef(({
                                     tagName: Tag,
                                     primary,
                                     success,
                                     large,
                                     small,
                                     className,
                                     children,
                                     ...props
                                   }, ref) => {
  const classes = useStyles();
  className = cn(classes.root, {
    [classes.primary]: primary,
    [classes.success]: success,
    [classes.large]: large,
    [classes.small]: small,
  }, className);

  children = (typeof children === 'string') ? <span>{children}</span> : children;

  return (
    <Tag ref={ref} className={className} {...props}>{children}</Tag>
  )
});

UIButton.propTypes = {
  tagName: PropTypes.any,
  primary: PropTypes.bool,
  success: PropTypes.bool,
  large: PropTypes.bool,
  small: PropTypes.bool,
};

UIButton.defaultProps = {
  tagName: 'button',
  tabIndex: 0,
};

export default UIButton;

const useStyles = createUseStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    color: '#fff',
    fontSize: defaultFontSize,
    fontWeight: boldFontWeight,
    textDecoration: 'none',
    borderRadius: 4,
    boxSizing: 'border-box',
    border: 0,
    cursor: 'pointer',
    textAlign: 'center',
    outline: 'none',
    userSelect: 'none',
    transition: [['background', '100ms', 'ease-in']],
    minHeight: 32,
    minWidth: 120,
    padding: [[4, 12]],

    '&:active': {
      transform: 'translate(0, 1px)'
    },

    backgroundColor: '#999',

    '&:hover, &:focus': {
      backgroundColor: darken('#999', .1),
    },

    '&:disabled, &:disabled:hover, &:disabled:focus, &:disabled:active': {
      backgroundColor: lighten('#999', .1),
      transform: 'none',
    }
  },

  primary: {
    backgroundColor: brandColor,

    '&:hover, &:focus': {
      backgroundColor: darken(brandColor, .1),
    },

    '&:disabled, &:disabled:hover, &:disabled:focus, &:disabled:active': {
      backgroundColor: lighten(brandColor, .1),
      transform: 'none',
    }
  },

  success: {
    backgroundColor: greenColor,

    '&:hover, &:focus': {
      backgroundColor: darken(greenColor, .1),
    },

    '&:disabled, &:disabled:hover, &:disabled:focus, &:disabled:active': {
      backgroundColor: lighten(greenColor, .1),
      transform: 'none',
    }
  },

  large: {
    minWidth: 160,
    minHeight: 40,
    padding: [[8, 12]],
  },

  small: {
    minHeight: 'auto',
    minWidth: 60,
    padding: [[3, 8]],
  }
});
